import Vue from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import lodash from 'lodash'
Vue.use(lodash)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
